import React from 'react';
import './OrbiterFooter.scss';

/**
 * Normalize Sitecore link field
 * - Local: object
 * - UAT: XML string
 */
const normalizeLinkField = (linkField) => {
  if (!linkField?.value) return null;

  // Local (resolved object)
  if (typeof linkField.value === 'object') {
    return {
      href: linkField.value.href || linkField.value.url,
      text: linkField.value.text,
      target: linkField.value.target || '_self',
    };
  }

  // UAT (XML string)
  if (typeof linkField.value === 'string') {
    const hrefMatch = linkField.value.match(/url="([^"]+)"/);
    const textMatch = linkField.value.match(/text="([^"]+)"/);
    const targetMatch = linkField.value.match(/target="([^"]+)"/);

    return {
      href: hrefMatch?.[1],
      text: textMatch?.[1],
      target: targetMatch?.[1] || '_self',
    };
  }

  return null;
};

const OrbiterFooter = (props) => {
  console.log('OrbiterFooter props:', props);

  const fields = props?.fields || {};

  // Logos
  const logoSrc = fields?.Logo?.value?.src;
  const logoAlt = fields?.Logo?.value?.alt || 'Orbiter Logo';

  // Arrays
  const features = fields?.Features || [];
  const socialLinks = fields?.SocialLinks || [];
  const policies = fields?.Policy || [];

  // ✅ Brochure (normalized)
  const brochureLink = normalizeLinkField(fields?.Brochure);
  const brochureText = brochureLink?.text || 'Download Brochure';
  const brochureArrow = fields?.BrochureImage?.value?.src || '';
  const brochureDescription = fields?.BrochureDescription?.value || '';

  // Copyright
  const copyrightText = fields?.Copyright?.value || '©2025 TVS Motor Company. All Rights Reserved';

  return (
    <footer className="footer footer-bg-orbiter">
      <div className="container-md">
        <div className="row">
          {/* Logo & Social */}
          <div className="col-lg-4">
            {logoSrc && (
              <div className="footer-logo">
                <a href="/">
                  <img src={logoSrc} alt={logoAlt} className="footer-brand-logo lazyloaded" />
                </a>
              </div>
            )}

            <div className="social-links">
              {socialLinks.map((item, index) => {
                const imageSrc = item?.fields?.image?.value?.src;
                const linkHref = item?.fields?.link?.value?.href || item?.fields?.link?.value?.url;
                const title = item?.fields?.title?.value;

                if (!imageSrc || !linkHref) return null;

                return (
                  <a
                    key={index}
                    href={linkHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="brandcta-trigger"
                    data-event="footer_social_media_click"
                    aria-label={title}
                  >
                    <img src={imageSrc} alt={title || ''} />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Internal Links */}
          <div className="col-lg-4">
            <div className="footer-internal-links">
              {features.map((item, index) => {
                const title = item?.fields?.title?.value;
                const linkHref = item?.fields?.link?.value?.href || item?.fields?.link?.value?.url;

                if (!title || !linkHref) return null;

                return (
                  <a
                    key={index}
                    href={linkHref}
                    className="brandcta-trigger"
                    data-event="footer_navigation_click"
                  >
                    {title}
                  </a>
                );
              })}
            </div>
          </div>

          {/* ✅ Brochure */}
          <div className="col-lg-3">
            <div className="footer-pricing-link download-brochure">
              {brochureLink?.href && (
                <a
                  href={brochureLink.href}
                  className="brandcta-trigger d-flex"
                  data-event="footer_navigation_click"
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                >
                  {brochureText}&nbsp;
                  <span>
                    <img src={brochureArrow} alt="download" />
                  </span>
                </a>
              )}
            </div>

            {brochureDescription && (
              <div className="footer-internal-links" style={{ borderRight: 'none' }}>
                <a className="footerlinks-content">{brochureDescription}</a>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Policy Links + Copyright */}
      <div className="orbiter-copyrights">
        <div className="container-md border-t">
          <div className="row">
            <div className="col-lg-7 text-left">
              <div className="footer-links">
                {policies.map((item, index) => {
                  const title = item?.fields?.title?.value;
                  const linkHref =
                    item?.fields?.link?.value?.href || item?.fields?.link?.value?.url;

                  if (!title || !linkHref) return null;

                  return (
                    <a
                      key={index}
                      href={linkHref}
                      className="brandcta-trigger"
                      data-event="footer_navigation_click"
                    >
                      {title}
                    </a>
                  );
                })}
              </div>
            </div>

            <div className="col-lg-5 text-right">
              <div className="copyrights-text">{copyrightText}</div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default React.memo(OrbiterFooter);
